import Api from "../apiService";

class CargoItemsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/cargo/items`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/cargo/items/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/cargo/items`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/items/${id}`,
      data,
      Api.authHeaders()
    );
  }

  delete(companyId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/cargo/items/${id}`,
      {},
      Api.authHeaders()
    );
  }
}

export default new CargoItemsApi();
